
import React from 'react'
import { BrowserRouter, Routes ,Route } from 'react-router-dom'

import Main from '../_layout/Main'
import MainAdmin from '../_layout/MainAdmin/MainAdmin'
import LayoutWeb from '../_layout/LayoutWeb'
import LayoutAdmin from '../_layout/LayoutAdmin'
import LayoutEst from '../_layout/layoutEst/LayoutEst'
import LayoutEstMenu from '../_layout/layoutEstMenu/LayoutEstMenu' 
import LayoutLte from '../_layout/adminLTE/LayoutLte'
import LayoutLteBasic from '../_layout/adminLTEBasic/LayoutLteBasic'

// views
import About from '../views/About'

import Login from '../views/login/Login'
import Signup from '../views/login/Signup'
import EstudiantePreins from '../views/web_all/EstudiantePreins'
import EstudianteP from '../views/web_all/EstudianteP'


// Main Admin Views

import Admin from '../views/Admin'
import Dashboard from '../views/Dashboard'
import Panel from '../views/admin_all/Panel'
import Ticket from '../views/Ticket'

import Certificado1 from '../views/Certificado1'
import CertificadoList from '../views/CertificadoList'


import CambiarClave from '../views/CambiarClave'
import CambiarClaveA from '../views/CambiarClaveA'
import ProductoList from '../views/producto_crud/ProductoList'
import Producto from '../views/producto_crud/Producto'

import Settings from '../views/Settings'


// admin Views
import Home from '../views/Home'


import List_crud from '../views/List_crud'
import CrudModal from '../views/CrudModal'
import Crud_ok from '../views/Crud_ok'

import Citas from '../views/cita_all/Citas'

//-----------------ADMIN ALL-------------
import MateriaList from '../views/admin_all/materia_crud/MateriaList'
import CategoriaList from '../views/admin_all/categoria_crud/CategoriaList'
import CarreraList from '../views/admin_all/carrera_crud/CarreraList'

import EstudianteList from '../views/admin_all/estudiante_crud/EstudianteList'
import Estudiante from '../views/admin_all/estudiante_crud/Estudiante'

import DocenteList from '../views/admin_all/docente_crud/DocenteList'
import Docente from '../views/admin_all/docente_crud/Docente'
import Globalx from '../views/admin_all/globalx'

//---asignaciones
import Docente_materiaList from '../views/admin_all/docente_materia_crud/Docente_materiaList'
import MateriaDocenteList from '../views/admin_all/materia_docente_crud/MateriaDocenteList'

import PrograBuscarCi from '../views/admin_all/programacion_crud/PrograBuscarCi'
import ProgramacionList from '../views/admin_all/programacion_crud/ProgramacionList'
import PrograCambiaGrupo from '../views/admin_all/programacion/PrograCambiaGrupo'

import ImportarEstXMateria from 'views/admin_all/importar_est_x_materia/ImportarEstXMateria'
import ImportarEst from 'views/admin_all/importar_est/ImportarEst'

import HabilitarPreinsList from 'views/admin_all/habilitar_preins/HabilitarPreinsList'
import Inscripcion from 'views/admin_all/inscribir/Inscripcion'
import InscribirEstXCi from 'views/admin_all/inscribir_est_x_ci/InscribirEstXCi'

import PassRestaDoc from 'views/admin_all/pass_resta_doc/PassRestaDoc'
import PassRestaEst from 'views/admin_all/pass_resta_est/PassRestaEst'

import HabPreinsCarrera from 'views/admin_all/preins_carrera/HabPreinsCarrera'
import UsuarioList from 'views/admin_all/usuarios_crud/UsuarioList'
import PrograList from 'views/admin_all/progra_crud/PrograList'
import HabLlenadoNotas from 'views/admin_all/hab_llenado_notas/HabLlenadoNotas'


//-------------- debug all
import MenuDebug from 'views/debug_all/MenuDebug'
import DebugCompareDB from 'views/debug_all/DebugCompareDB'
import Reset from 'views/debug_all/Reset'
import ResetPassEst from 'views/debug_all/ResetPassEst'


//-------reportes
import RepEstXMateria from 'views/reportes_all/RepEstXMateria'
import RepMateXCarrera from 'views/reportes_all/RepMateXCarrera'
import RepMateXDoc from 'views/reportes_all/RepMateXDoc'
import CertNotas from 'views/reportes_all/CertNotas'
import HistorialAcad from 'views/reportes_all/HistorialAcad'



//------------ EST -----------------------------------
import CursosSelList from 'views/estudiante_all/CursosSelList'
import CursoMain from 'views/estudiante_all/CursoMain'
import Participantes from 'views/estudiante_all/Participantes'
import CalificacionEst from 'views/estudiante_all/CalificacionEst'
import TareaEst from 'views/estudiante_all/TareaEst'
import TareaEstNuevo from 'views/estudiante_all/TareaEstNuevo'
import AsistenciaEst from 'views/estudiante_all/AsistenciaEst'
import NotasEst from 'views/estudiante_all/NotasEst'
import MiPerfilE from 'views/estudiante_all/MiPerfilE'
import MiProgramacion from 'views/estudiante_all/MiProgramacion'
import ProgramarMat from 'views/estudiante_all/ProgramarMat'

import PlanEstudios from 'views/estudiante_all/PlanEstudios'



//-------------- DOCENTE ---------------------------------
import CursosdSelList from 'views/docente_all/CursosdSelList'
import CursodMain from 'views/docente_all/CursodMain' 
import Estudiantes from 'views/docente_all/Estudiantes' 
import TemaList from 'views/docente_all/tema_crud/TemaList' 

import Asistencia2List from 'views/docente_all/asistencia2_fecha/Asistencia2List' 
import Asistencia2 from 'views/docente_all/asistencia2/Asistencia2' 
import TablaAsistencia from 'views/docente_all/TablaAsistencia' 

import KardexEst from 'views/docente_all/kardex_est/KardexEst' 
import EstudBuscar from 'views/docente_all/estud_buscar/EstudBuscar' 
import CambiarClaved from 'views/docente_all/CambiarClaved' 
import Configd from 'views/docente_all/Configd' 
 
import Notasd from 'views/docente_all/Notasd' 
import TareaRevList from 'views/docente_all/tarea_revisar/TareaRevList'
import TareaRevList2 from 'views/docente_all/tarea_revisar/TareaRevList2'

import ExamendRevList from 'views/docente_all/examend_revisar/ExamendRevList'
import ExamendRevListEst from 'views/docente_all/examend_revisar/ExamendRevListEst'

import TablaNotas from 'views/docente_all/TablaNotas' 
import TablaNotasFin from 'views/docente_all/TablaNotasFin' 

import TablaNotasCentral from 'views/docente_all/TablaNotasCentral' 
import TablaNotasCentralFin from 'views/docente_all/TablaNotasCentralFin' 

import TareadList from 'views/docente_all/taread_crud/TareadList' 
import Taread from 'views/docente_all/taread_crud/Taread' 

import ExamendList from 'views/docente_all/examend_crud/ExamendList' 
import Examend from 'views/docente_all/examend_crud/Examend'



//-----------------------------------------------------------

import CitasHoy from 'views/cita_all/CitasHoy'

//------------------ PACIENTE_ALL --------------------


import MedicosCrud from '../views/medicos_crud/Index'
import CitaHoraCrud from '../views/CitaHora_crud'




import Consultas from 'views/consultas/Consultas'


//--pacientes



// eslint-disable-next-line import/no-anonymous-default-export
export default () => {

  /*<Route path="/items/:itemId" element={<ItemsDetail />} />
  <Route path='/certificado1/:id/:ope' exact element={ <Certificado1 />} /> 
  <Route path='/certificado1/:id/:ope' exact element={ <Certificado1 {...props} />} /> */
  return (
    <>
      <Routes>
        
        <Route path='/signup' element={ <Signup />} />
    
        <Route element={<LayoutWeb />}>
          <Route path='/login' element={ <Login />} />
          <Route path='/estudiante_preins' element={ <EstudiantePreins />} />
          <Route path='/estudiantep/:ope/:idd' element={ <EstudianteP />} />
          
        </Route>
        {/*       ADMIN     */}
        <Route element={<LayoutAdmin />}>
          <Route path='/admin'  element={<Admin />} />    
          <Route path='/admin/settings' element={ <Settings />} />
          <Route path='/panel' exact element={ <Panel />}  />
          <Route path='/materialist' exact element={ <MateriaList />} /> 
          <Route path='/categorialist' exact element={ <CategoriaList />} /> 
          <Route path='/carreralist' exact element={ <CarreraList />} /> 
          
          <Route path='/docentelist' exact element={ <DocenteList />} /> 
          <Route path='/docente/:ope/:idd' exact element={ <Docente />} /> 

          <Route path='/estudiantelist' exact element={ <EstudianteList />} /> 
          <Route path='/estudiante/:ope/:idd' exact element={ <Estudiante />} /> 

          <Route path='/docente_materialist' exact element={ <Docente_materiaList />} /> 
          <Route path='/materia_docentelist' exact element={ <MateriaDocenteList />} /> 

          <Route path='/prograbuscarci' exact element={ <PrograBuscarCi />} /> 
          <Route path='/programacionlist/:id' exact element={ <ProgramacionList />} /> 
          <Route path='/progra_cambia_grupo' exact element={ <PrograCambiaGrupo />} /> 

          <Route path='/importarestxmateria' exact element={ <ImportarEstXMateria />} /> 
          <Route path='/importarest' exact element={ <ImportarEst />} /> 

          <Route path='/habilitar_preinslist' exact element={ <HabilitarPreinsList />} /> 
          <Route path='/inscripcion' exact element={ <Inscripcion />} /> 
          <Route path='/inscribir_est_x_ci' exact element={ <InscribirEstXCi />} /> 

          <Route path='/pass_resta_doc' exact element={ <PassRestaDoc />} /> 
          <Route path='/pass_resta_est' exact element={ <PassRestaEst />} /> 

          <Route path='/hab_preins_carrera' exact element={ <HabPreinsCarrera />} /> 
          <Route path='/globalx' exact element={ <Globalx />} /> 
          <Route path='/usuarios' exact element={ <UsuarioList />} /> 
          <Route path='/progra_list' exact element={ <PrograList />} /> 

          <Route path='/hab_llenado_notas' exact element={ <HabLlenadoNotas />} /> 
          

          

          {/**-----------reportes-------- */}
          <Route path='/rep_est_x_materia' exact element={ <RepEstXMateria />} /> 
          <Route path='/rep_mate_x_carrera' exact element={ <RepMateXCarrera />} /> 
          <Route path='/rep_mate_x_docente' exact element={ <RepMateXDoc />} /> 
          <Route path='/cert_notas' exact element={ <CertNotas />} /> 
          <Route path='/historial_acad' exact element={ <HistorialAcad />} /> 
          

          {/*--------- DEBUG */}
          <Route path='/menu_debug' exact element={ <MenuDebug />} /> 
          <Route path='/debug_compare_db' exact element={ <DebugCompareDB />} /> 
          <Route path='/reset' exact element={ <Reset />} /> 
          <Route path='/reset_pass_est' exact element={ <ResetPassEst />} /> 
          

        </Route>

        <Route element={<LayoutEst />}>
          <Route path='/cursos_sel_list' exact element={ <CursosSelList />} />
                    
        </Route>

        <Route element={<LayoutEstMenu />}>
          <Route path='/curso_main/:id' exact element={ <CursoMain />} />
          <Route path='/participantes' exact element={ <Participantes />} />
          <Route path='/calificacion_est' exact element={ <CalificacionEst />} />
          <Route path='/tarea_est' exact element={ <TareaEst />} />
          <Route path='/tarea_est_nuevo/:id' exact element={ <TareaEstNuevo />} />
          <Route path='/asistencia_est' exact element={ <AsistenciaEst />} />
          <Route path='/notas_est' exact element={ <NotasEst />} />
          <Route path='/mi_perfil_e' exact element={ <MiPerfilE />} />
          <Route path='/mi_programacion' exact element={ <MiProgramacion />} />
          <Route path='/programar_mat' exact element={ <ProgramarMat />} />
          <Route path='/plan_de_estudios' exact element={ <PlanEstudios />} />
        
          
        </Route>

        {/* docente  */}
        <Route element={<LayoutLteBasic />}> 

          <Route path='/cursosd_sel_list' exact element={ <CursosdSelList />}  />
          
          
        </Route>

        {/* ------------------- DOCENTE con menu -------------------*/}
        <Route element={<LayoutLte />}>
          <Route path='/dashboard' exact element={ <Dashboard />}  />
          <Route path='/cursod_main/:id' exact element={ <CursodMain />}  />
          <Route path='/estudiantes' exact element={ <Estudiantes />}  />
          <Route path='/temas' exact element={ <TemaList />} />
          <Route path='/asistencia2_fecha' exact element={ <Asistencia2List />}  />
          <Route path='/asistencia2/:id' exact element={ <Asistencia2 />}  />
          <Route path='/tabla_asistencia' exact element={ <TablaAsistencia />}  />
          
          
          <Route path='/tarea_rev_list' exact element={ <TareaRevList />}  />
          <Route path='/tarea_rev_list2/:id' exact element={ <TareaRevList2 />}  />

          <Route path='/examend_rev_list' exact element={ <ExamendRevList />}  />
          <Route path='/examend_rev_list_est/:id' exact element={ <ExamendRevListEst />}  />

          <Route path='/notasd' exact element={ <Notasd />}  />
          <Route path='/tabla_notas/:id' exact element={ <TablaNotas />}  />
          <Route path='/tabla_notas_fin/:id' exact element={ <TablaNotasFin />}  />
          <Route path='/tabla_notas_central' exact element={ <TablaNotasCentral />}  />
          <Route path='/tabla_notas_central_fin' exact element={ <TablaNotasCentralFin />}  />
          

          <Route path='/taread_list' exact element={ <TareadList />} /> 
          <Route path='/taread/:id/:ope' exact element={ <Taread />} /> 

          <Route path='/examend_list' exact element={ <ExamendList />} /> 
          <Route path='/examend/:id/:ope' exact element={ <Examend />} /> 

          {/* ------utiles ----------- */}
          <Route path='/kardex_est/:id' exact element={ <KardexEst />}  />
          <Route path='/estud_buscar' exact element={ <EstudBuscar />}  />
          <Route path='/cambiar_claved' exact element={ <CambiarClaved />}  />
          <Route path='/configd' exact element={ <Configd />}  />

        </Route>

        <Route element={<LayoutLte />}>
        
          <Route path='/' exact element={ <Dashboard/>} />
          <Route path='/ticket' exact element={ <Ticket />} />  
          
          <Route path='/certificado1/:id/:ope' exact element={ <Certificado1 />} /> 
          <Route path='/certificado_list' exact element={ <CertificadoList />} /> 

          
          <Route path='/cambiarclave' exact element={ <CambiarClave />} /> 
          <Route path='/cambiarclaveA' exact element={ <CambiarClaveA />} /> 
          <Route path='/productolist' exact element={ <ProductoList />} /> 
          <Route path='/producto/:ope/:idd' exact element={ <Producto />} /> 


          <Route path='/settings' exact element={ <Settings />} /> 
           

          <Route path='/citas' exact element={ <Citas />} />         
          
          
          <Route path='/citas_hoy' exact element={ <CitasHoy />} /> 

          <Route path='/medicos' exact element={ <MedicosCrud />} /> 
          <Route path='/citahoras/:id' exact element={ <CitaHoraCrud />} /> 

          
          
          
        </Route>
    



        <Route element={<LayoutLteBasic />}>

          
          <Route path='/home' exact element={ <Home/>} />  
          <Route path='/about' element={ <About />} />
          <Route path='/list_crud' element={ <List_crud />} />
          <Route path='/crud_modal' element={ <CrudModal />} />
          <Route path='/crud_ok' element={ <Crud_ok />} />
        </Route>

        <Route path="*" element={<NoMatch />} /> 
      </Routes>

      

    </>
  )

};
const NoMatch = () => {
  return (<p>There's nothing here: 404!</p>);
};
